<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <div class="ms-5 mt-5 w-100">
        </div>
        <h2>{{$t('message.Region')}}</h2>
        <div>
          <b-card
              class="mt-4"
              style="width: 90%; margin: 0 auto;"
            >
            <b-table
                responsive
                striped
                hover
                :items="regions"
                :fields="fields">
              <template #cell(id)="data">
                <span class="text-md text-primary"> {{ (data.index + 1) }}</span>
              </template>
              <template #cell(action)="data">
                <b-button
                    variant="primary"
                    style="margin-left: 10px;background-color: #185d89"
                    size="sm"
                    @click="handlePush(data.item.id)"
                ><i class='bx bx-show'></i>
                </b-button>
              </template>
            </b-table>
          </b-card>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getRegions} from "../../../../../../../api/regions";
import HorizontalTopbarInside from "../../../../../../../components/horizontal-topbar-inside";


export default {
  name: "Regions",
  components: {
    HorizontalTopbarInside,

    SideBar
  },
  data() {
    return {
      id: null,
      activeModal: false,
      isMenuCondensed: false,
      regions: [],
      fields: [
        {
          key: 'id',
          label: this.$t('message.Id'),
        },
        {
          key:'nameuz',
          label: this.$t('message.Region')
        },
        {
          key:'nameru',
          label: this.$t('message.Region_ru')
        },
        {
          key: 'action',
          label: this.$t('message.Action')
        }
      ],
    };
  },
  computed: {
    ...layoutComputed,
  },
  created (){
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchRegions()
  },
  methods: {
    fetchRegions(){
      getRegions().then(response => {
        this.regions = response.data.data
      })
    },
    getData(){
      this.activeModal = false
      this.fetchRegions()
    },
    handlePush(id){
      this.$router.push({ name: 'region',params: {id}})
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
.bx{
  font-size: 19px;
}
</style>



